import { render, staticRenderFns } from "./LabourRatesShow.vue?vue&type=template&id=7077ff06&"
import script from "./LabourRatesShow.vue?vue&type=script&lang=js&"
export * from "./LabourRatesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports